import { Close } from '@mui/icons-material';
import { IconButton, Theme } from '@mui/material';
import { alpha, SxProps } from '@mui/material/styles';

interface CloseIconProps {
  onClick?: (e?: any) => void;
  sx?: SxProps<Theme>;
  className?: string;
}

export const CloseIcon = ({ onClick, sx, className }: CloseIconProps) => {
  return (
    <IconButton
      aria-label="close"
      onClick={onClick}
      sx={({ palette }) => ({
        zIndex: 2,
        background: alpha(palette.background.paper, 0.8),
        ...(sx as any), // sx doesn't inherit type match for theme destructure
      })}
      className={className}
    >
      <Close />
    </IconButton>
  );
};
